import classes from "./cancel.styles.module.scss";
import {useParams} from "react-router-dom";
import {useAppContext} from "../../AppContext";
import {useEffect, useState} from "react";
import {CircularProgress} from "@mui/material";

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

const formatDateRu = (date: Date): string =>
  date.toLocaleDateString("ru-RU", DATE_FORMAT_OPTIONS) + " г.";

const formatDateParam = (value: string | undefined | null): string | null => {
  if (!value) return null;
  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) return null;
  return formatDateRu(parsedDate);
};

export const CancelPaymentSubscribePage = () => {
  const {dateUntil, token} = useParams();
  const {api} = useAppContext();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    if (!token) {
      return;
    }
    setLoading(true);
    api.authApi.verifyShortToken(token)
      .then(res => {
        if (res.errors && res.errors.length > 0) {
          setError(res.errors[0]);
        }
      })
      .finally(() => setLoading(false));
  }, [token, api.authApi]);
  
  const loading = () => <div className={classes.page}>
    <CircularProgress sx={(theme) => ({color: '#000', zIndex: 1001})} color="inherit"/>
  </div>;
  
  return isLoading ?  loading() : <div className={classes.page}>
    <div className={classes.header}>
      Подписка отменена
    </div>
    
    <div className={classes.content}>
      <div className={classes.contentItem}>
        Дополнительные функции будут доступны до {formatDateParam(dateUntil)}.
      </div>
      <div className={classes.contentItem}>
        Вы можете возобновить подписку в любой момент
      </div>
      <div className={classes.contentItem}>
        <div className={classes.error}>
          {error}
        </div>
      </div>
      
      <div className={classes.messagePadding}>
        <div className={classes.messageItem}>
          Закройте это окно, чтобы вернуться в приложение
        </div>
      </div>
    </div>
  </div>
}